import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";

import banner3 from "../assets/banner3.jpg"; // main floating image
import { FaUserTie } from "react-icons/fa6";
import overlay from "../assets/overlay.jpg";

export default function AboutUsContent() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 900, once: false, easing: "ease-out-cubic" });
  }, []);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center py-5">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="MainBodySection py-5 position-relative" style={{backgroundImage: `url(${overlay})`,
        backgroundSize: "cover",
        backgroundPosition: "center",}}>
      <div className="container">
        <div className="row align-items-center">
          {/* Left Column - Text */}
          <div className="col-md-6" data-aos="fade-right">
            <h2 className="text-primary fw-bold mb-4">
              About Ndomano Group of Companies
            </h2>

            <p style={{ lineHeight: 1.7, fontSize: "1rem", marginBottom: "1.5rem" }}>
              Ndomano Group of Companies is a new-generation, tech-driven conglomerate founded by Peter Shihumbi Ndomano. Although officially registered in 2026, the group manages multiple brands and ventures that had been operating long before its formal establishment. Built on innovation, digital transformation, and a strong belief in African potential, Ndomano Group brings together companies across finance, mobility, logistics, pharmaceuticals, and technology.
            </p>

            <p style={{ lineHeight: 1.7, fontSize: "1rem", marginBottom: "1.5rem" }}>
              The group’s unified mission is to create solutions that transform everyday life and business in Tanzania and beyond. Each subsidiary operates under modern, tech-enabled approaches, ensuring efficiency, accessibility, and measurable impact for communities and businesses alike.
            </p>

            <p style={{ lineHeight: 1.7, fontSize: "1rem", marginBottom: "1.5rem" }}>
              With a focus on strategic growth, digital innovation, and operational excellence, Ndomano Group leverages technology to scale solutions while maintaining high standards of integrity, quality, and social responsibility across all sectors.
            </p>
          </div>

          {/* Right Column - Image */}
          <div className="col-md-6 position-relative mt-4 mt-md-0" data-aos="fade-down">
            <div
              className="rounded overflow-hidden mShadow2 position-relative"
              style={{
                width: "100%",
                maxWidth: "420px",
                margin: "0 auto",
              }}
            >
              <img
                src={banner3}
                alt="Ndomano Group"
                className="img-fluid rounded"
              />

              {/* Small Ownership Card */}
              <div
                className="position-absolute d-flex align-items-center"
                style={{
                  top: "16px",
                  left: "16px",
                  background: "rgba(255,255,255,0.9)",
                  borderRadius: "12px",
                  padding: "0.5rem 1rem",
                  backdropFilter: "blur(6px)",
                  border: "1px solid rgba(0,0,0,0.08)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  gap: "0.5rem",
                }}
              >
                <FaUserTie size={20} color="#00356d" />
                <span className="fw-semibold" style={{ fontSize: "0.9rem", color: "#00356d" }}>
                  Founded by Peter Ndomano
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
